module.exports = __webpack_public_path__ + "static/media/banner5-mob.77c799b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/banner5-mob.png
// module id = 46
// module chunks = 0